var ApplicationAPI = require('../../../common/api').Application;
var ApplicantAPI = require('../../../common/api').Applicant;
var ReportAPI = require("../../../common/api").Report;
var Promise = require('bluebird');


module.exports = function ($scope, $state, ngDialog) {
  var vm = this;
  vm.loading = false;
  vm.list = [];
  vm.status = 20;




  vm.goToApplication = function(appId) {
    $state.go('applicant.application', {id: appId});
  }

  vm.getApplications = function(){

    vm.loading = true;

    return ApplicationAPI.GetApplications(vm.searchText, vm.status).then(function(resp){
      var items = [];
      resp.forEach(function(item){
          items.push(item)
      })
      vm.list = items;
    }).finally(function(){
      vm.loading = false;
    });
  }

  $scope.getApplicant = function(){
    ApplicantAPI.GetOwnApplicant("ApplicantDropdownView").then(function(result){
      $scope.applicant = result;
    });
  }

  vm.showHideFunders = function(app){
    app.showFunders = !app.showFunders;
  }


  function init()
  {
    vm.getApplications();
    Promise.all([
      ReportAPI.GetReportsByType(7)])
    .then(function(results){
      vm.applicationReports = [];
      for (var i = 0; i < results[0].length; i++){
        vm.applicationReports.push(results[0][i]);
      }
      if(results[1]){
        for (var i = 0; i < results[1].length; i++){
          vm.applicationReports.push(results[1][i]);
        }
      }
    });
    $scope.getApplicant();
  }

  init();
}
